import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import MailIcon from '@mui/icons-material/Mail';
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Button, Dialog, DialogContent, DialogContentText, DialogTitle, IconButton } from "@mui/material";
import Style from "../../Styles/CssModulesGlobal.module.scss";
import PropTypes from 'prop-types';
import CustomToolTip from "../../common/CustomToolTip/CustomToolTip";

const stepsToSetGoogleDoc = <React.Fragment>
<ul>
    <li>Open your Google Doc</li>
    <li>Click the <b>Share</b> button in the top right</li>
    <li>Under General access click the down arrow</li>
    <li>Select Anyone with the link</li>
    <li>Click Copy link</li>
    <li>Click Done</li>
    <li>Paste the copied link into College Contact’s Document Submission Form</li>
</ul>
</React.Fragment>;
  
  const CustomDialog = (props) => {

    const {openPopup, handleClose, reloadForm, messageSuccess, messageReview, additionalContent, confirmPop, iconChange, iconSuccess, 
      submitDocument, backButton, submitButton, iconConfirmation, messageTitle, infoIcon,  showInfoIcon = false, showButton = true, size="sm", showCloseBtn = true } = props;

    return (
      <Dialog
        open={openPopup}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth={size}
      >
        {showCloseBtn && (<IconButton
          aria-label="close"
          className={Style.closeDialog}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>)}
  
        <DialogContent sx={{ textAlign: "center" }}>
          {iconChange &&
          <MailIcon sx={{ fontSize: "48px", color: "#44A4EB" }} />
          }
          {infoIcon && 
          <InfoOutlinedIcon sx={{ fontSize: "58px", color: "#44A4EB" }}/>
          }
          {(iconSuccess || confirmPop) &&
           <CheckCircleIcon sx={{ fontSize: "78px", color: "#44A4EB" }} />
          }
          {iconConfirmation &&
            <WarningAmberIcon sx={{ fontSize: "78px", color: "#ff0000" }} />
          }
          {confirmPop &&
          <DialogTitle
            sx={{ fontSize: "32px", fontWeight: "600", pt: 0 }}
            id="alert-dialog-title"
          >
            {messageSuccess}
          </DialogTitle>
          }
          {messageTitle &&
          <DialogTitle sx={{ fontSize: "24px", fontWeight: "600", pt: 0 }} id="alert-dialog-title">{messageTitle}</DialogTitle>
          }
          <DialogContentText
            sx={{ fontSize: "16px", fontWeight: "500", color: "#333", mb: 3 }}
            id="alert-dialog-description"
          >
          <div className="icon-wrapper">
          <span>
            <Box sx={{display:"flex", flexDirection: "column"}}>
            {messageReview}
              { showInfoIcon && (<CustomToolTip info={stepsToSetGoogleDoc} />)}
              </Box>
            </span>
          </div>
          </DialogContentText>
          {confirmPop && showButton &&
          <Button variant="contained">
            {reloadForm}
          </Button>
          }
          
          {submitButton && 
           <Button variant="contained" sx={{ padding: "4px 22px", fontSize: 16}} onClick={submitDocument} >
           {submitButton}
           </Button>
          }
           {backButton && 
           <Box sx={{ mt: 1 }}>
            <Button  variant="outlined" sx={{ padding: "4px 22px", fontSize: 16}} onClick={reloadForm}>
              {backButton}
            </Button>
           </Box>
          }
          <Box sx={{ width: "100%", mt: 1 }}>
          {additionalContent}
          </Box>
        </DialogContent>
      </Dialog>
    );
  };
  
  export default CustomDialog;

  CustomDialog.propTypes = {
    openPopup: PropTypes.bool.isRequired,
    messageSuccess:PropTypes.string.isRequired,
    messageReview:PropTypes.string.isRequired,
    size:PropTypes.string,
    handleClose: PropTypes.func.isRequired,
    reloadForm: PropTypes.func.isRequired,
    additionalContent:PropTypes.element.isRequired,
    confirmPop:PropTypes.element.isRequired,
    iconChange:PropTypes.bool.isRequired,
    iconSuccess:PropTypes.bool.isRequired,
    submitDocument:PropTypes.func.isRequired, 
    backButton:PropTypes.element.isRequired,
    submitButton:PropTypes.element.isRequired,
    iconConfirmation:PropTypes.bool.isRequired,
    showInfoIcon: PropTypes.bool,
    messageTitle: PropTypes.string,
    infoIcon: PropTypes.string,
    showButton: PropTypes.bool,
    showCloseBtn: PropTypes.bool,
  };
  